import React from 'react'
import styled from '@emotion/styled'
import { Progress } from '@chakra-ui/core'

type IProps = {
  value: number
}

const StyledProgress = styled(Progress)`
  width: 100%;
  border-radius: 2px;
  & div {
    background-color: #50e150;
  }
`

const ProgressBar: React.FC<IProps> = (props: IProps) => {
  const { value } = props
  return <StyledProgress value={value} size="md" hasStripe />
}

export default ProgressBar
